
import { useTranslation } from "react-i18next";
import Hero from "../../components/root/Hero";
import CareerGuide from "../../components/root/CareerGuide";
import backgroundImage from "../../assets/new images/careerguide.png";
import img1 from "../../assets/new images/howitworks1.png";
import img2 from "../../assets/new images/howitworks2.png";
import img3 from "../../assets/new images/howitworks3.png";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";
const Home = () => {
    const { t } = useTranslation();
    // NOTE: `steps` below is unused dead code (no HowItWorks section renders it in this page) — left as-is, no scope creep. Reuses existing howItWorks.* keys since the copy matches the Home page steps verbatim.
    const steps = [
        {
            img: img1,
            title: t("howItWorks.step1Title"),
            desc: t("howItWorks.step1Desc"),
        },
        {
            img: img2,
            title: t("howItWorks.step2Title"),
            desc: t("howItWorks.step2Desc"),
        },
        {
            img: img3,
            title: t("howItWorks.step3Title"),
            desc: t("howItWorks.step3Desc"),
        },
    ];
    return (
        <div className="font-sans overflow-x-hidden">
            <Seo
              {...SEO["/career-guide"]}
              path="/career-guide"
            />

            <Hero bgImage={backgroundImage}
                badgeText={`✨ ${t("hero.badge")}`}
                titleLines={[t("careerGuide.heroTitle")]}
                subtitle={t("careerGuide.heroSubtitle")}
                primary={{ label: t("careerGuide.accessCta"), href: "" }}
                curveColor="#F9FAFB"     // match the next section's background (e.g., Tailwind bg-gray-50)
                heightClass="h-[100vh] min-h-[560px]"
                overlayClass="bg-gradient-to-b from-black/55 via-black/35 to-black/25"
                roundedButtons={true} />
            
            <CareerGuide />
           

        </div>
    );
};

export default Home;
